var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.06 3.94.44-.44a4.95 4.95 0 0 1 7 7l-.44.44-7-7Zm-2.12 2.12-7.77 7.77c-1.366 1.366-2.05 2.05-2.608 2.82-.497.686-.919 1.421-1.26 2.195-.385.871-.631 1.806-1.123 3.675l-.132.501c-.344 1.308-.516 1.962-.341 2.414a1.5 1.5 0 0 0 .859.86c.453.174 1.106.002 2.414-.342l.501-.132c1.87-.492 2.804-.738 3.675-1.122a12.003 12.003 0 0 0 2.194-1.26c.771-.56 1.455-1.243 2.821-2.61l7.77-7.768-7-7Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit28);
export default __webpack_public_path__ + "static/media/edit_28.ea12dfaa.svg";
export { ForwardRef as ReactComponent };